module.exports = __webpack_public_path__ + "img/mobmainimage.220480c6.svg";